import { BaseService } from "./baseService";

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const API_TIMEOUT: number = 600000 * 1.01;
export const BASE_HEADERS = {
  "Content-Type": "application/json",
};

export interface ResponseData<T> {
  message?: string;
  data: T;
}

class AuthService extends BaseService<any> {
  controllerName = "auth";
  async logout(): Promise<ResponseData<any>> {
    this.api.defaults.headers = this.getDefaultHeaders();

    const { data } = await this.api.post(`/${this.controllerName}/logout`);

    return data;
  }

  async login(email: string, password: string): Promise<ResponseData<any>> {
    this.api.defaults.headers = this.getDefaultHeaders();

    const { data } = await this.api.post(`/emailauth/login`, {
      email,
      password,
    });
    return data;
  }

  async exchange(token: string): Promise<ResponseData<any>> {
    this.api.defaults.headers = this.getDefaultHeaders();

    const { data } = await this.api.post(
      `/${this.controllerName}/exchange`,
      undefined,
      {
        headers: {
          ...BASE_HEADERS,
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return data;
  }

  async embedToken(id: string) {
    this.api.defaults.headers = this.getDefaultHeaders();
    const { data } = await this.api.get<ResponseData<string>>(
      `/${this.controllerName}/powerBIEmbedToken/${id}`
    );
    return data;
  }

  async generateOtp(): Promise<ResponseData<any>> {
    this.api.defaults.headers = this.getDefaultHeaders();

    const { data } = await this.api.post(
      `/${this.controllerName}/generate-otp`,
    );
    return data;
  }

  async verifyOtp(otpToken: string): Promise<ResponseData<any>> {
    this.api.defaults.headers = this.getDefaultHeaders();

    const { data } = await this.api.post(
      `/${this.controllerName}/verify-otp`,
      {
        token: otpToken,
      },
    );
    return data;
  }

  async disableOtp(): Promise<ResponseData<any>> {
    this.api.defaults.headers = this.getDefaultHeaders();

    const { data } = await this.api.post(
      `/${this.controllerName}/disable-otp`,
    );
    return data;
  }
}

export const authService = new AuthService();
